import { XYChart, XYChartReportVM } from '../revoreporting/AmChartWrapper';

export class XYChart2Lines extends XYChart {
    success(data: object): void {
        let vm = new XYChartReportVM();
        vm.parseJson(data);
        if (vm.data.data.length === 0) {
            this.showChart(false);
        } else {
            this.showChart(true);
        }
        if (!this.isInitialized) {
            this.addXAxis(vm.category, vm.IsHorizontalChart);
            this.addValueAxis(vm.IsHorizontalChart);
            this.addSeries(vm.category, vm.value, true, "A: {categoryX} [bold]{value}[/]");
            if (vm.data.data[0]["valueperf"]>0) {
                console.log("found valueperf");
                this.addSeries(vm.category, "valueperf", true, "P: {categoryX} [bold]{valueperf}[/]");
            }
            this.isInitialized = true;
        }

        this.addData(vm.data);
        //this.ondataValidatedFunction(vm.IsHorizontalChart);

    }
}